function showAnnounceSale() {
  const modal = new tingle.modal({
    footer: false,
    stickyFooter: false,
    closeMethods: ["overlay", "button", "escape"],
    closeLabel: "Close",
    cssClass: ["enable-on-mobile", "announce-sale-modal"],
    onOpen: function () {},
    onClose: function () {},
    beforeClose: function () {
      return true;
    },
  });
  modal.setContent(
    `  <style>    
    html:has(.announce-sale-modal.tingle-modal--visible) {
  overflow: hidden;
}
   .tingle-modal.announce-sale-modal .tingle-modal-box__content{
      height:525px;
      }
   .red-color-text{
     color:var(--red-color);
   }
     .sale-popup .tabs {
        display: flex;
        gap: 24px;
        border-bottom: 1px solid #eee;
        margin-bottom: 16px;
        --popup-max-width:600;
        overflow:scroll;
        white-space:nowrap;
      }
      .sale-popup .tabs::-webkit-scrollbar{
      display:none;
      }
     .sale-popup .tab {
        padding-bottom: 6px;
        cursor: pointer;
        font-weight: bold;
        color: #000;
      }
     .sale-popup .tab.active {
        color: var(--red-color);
        border-bottom: 2px solid var(--red-color);
      }
     .sale-popup .tab-content {
        display: none;
        font-size: 14px;
        line-height: 1.6;
        color: #222;
      }
     .sale-popup .tab-content.active {
        display: block;
      }
      
    </style><div class="sale-popup" id="sale-popup">
      <h2 class="mt-0 mb-20 pb-20" style="color:#381708">Freshine Sales Service</h2>
      <div class="tabs">
              <div class="tab active" onclick="showTab(0)">Buy More, Save More</div>

        <div class="tab" onclick="showTab(1)">New Customer Offer</div>
        <div class="tab" onclick="showTab(2)">Up to 20% OFF Sitewide</div>
        <div class="tab" onclick="showTab(3)">Fast & Free Shipping</div>
        <div class="tab" onclick="showTab(4)">30-Day Returns</div>
      </div>

  <div class="tab-content active">
        <div>
          The more you buy, the more you save—automatically:
          <p>• Save <span class="red-color-text bold"> $100</span> on orders over <span class="bold" style="color:#222">$399</span></p>
          <p>• Save <span class="red-color-text bold"> $200</span> on orders over <span class="bold" style="color:#222">$699</span></p>
          <p>• Save <span class="red-color-text bold">$300 </span>on orders over <span class="bold" style="color:#222">$999</span></p>
          <p>• Save <span class="red-color-text bold"> $600</span> on orders over <span class="bold" style="color:#222">$1999</span></p>
          <p>Plus, enjoy extra savings with exclusive codes:</p>
          <p>• Get <span class="red-color-text bold">10%</span> OFF on orders under <span class="bold" style="color:#222">$2999</span> — Code:  <span class="red-color-text bold">EXTRA10</span></p>
          <p>• Get <span class="red-color-text bold">20%</span> OFF on orders over <span class="bold" style="color:#222">$2999</span> — Code:  <span class="red-color-text bold">EXTRA20</span></p>
          <p>Free & Fast Shipping on All Orders!</p>
          <p style="color:#dbdbdb">No code needed. Discount applies at checkout.</p>
        </div>
      </div>
      <div class="tab-content">
        <div>
          <p>Welcome!</p>
          <p>Get <span class="red-color-text bold">$100</span> OFF your first order when you spend <span class="bold" style="color:#222">$299</span> or more.</p>
          <p>Use code <span class="red-color-text bold">NEW</span> at checkout.</p>
          <p>And yes, it stacks with our Up to <span class="red-color-text bold">20%</span> OFF Sitewide sale!</p>
        </div>
      </div>
       <div class="tab-content">
        <div>
          <p>Enjoy extra savings with our exclusive codes:</p>
          <p>Get <span class="red-color-text bold"> 10%</span> on orders under <span class="bold" style="color:#222">$2999</span> — Code:<span class="red-color-text bold"> EXTRA10</span></p>
          <p>Get <span class="red-color-text bold"> 20%</span> on orders over <span class="bold" style="color:#222">$2999</span> — Code:<span class="red-color-text bold"> EXTRA20</span></p>
          <p>These discounts stack with our major savings offer—up to <span class="red-color-text bold">$600</span> OFF.</p>
          <p>Double your savings when you order today!</p>
        </div>
      </div>
      <div class="tab-content">
        <div>
          <p>
            We offer free shipping on all orders within the contiguous U.S. (48
            states).
          </p>
          <p>Every curtain is handmade and custom-tailored just for you.</p>
          <p>
            Orders typically ship within <span class="bold" style="color:#222">2–7</span> business days, with an additional
           <span class="bold" style="color:#222">5–7</span> days for delivery.
          </p>
          <p>
            So from the time you place your order to the moment it arrives at
            your door, it usually takes 7–14 days total— that’s more than twice
            as fast as many other custom curtain shops!
          </p>
        </div>
      </div>
  
      <div class="tab-content">
        <div>
          <p>We want you to be happy with your curtains.</p>
          <p>
            If we made a mistake, we’ll remake it or give you a full refund.
          </p>
          <p>
            If you made a mistake, you can reorder the same item for  <span class="red-color-text bold">50%</span> off.
          </p>
          <p>
            Custom items can be returned within 30 days. Please contact us and
            we’ll help right away.
          </p>
        </div>
      </div>
    </div>
    `
  );
  modal.open();
}
function showTab(index) {
  const tabs = document.querySelectorAll(".sale-popup .tab");
  const contents = document.querySelectorAll(".sale-popup .tab-content");
  tabs.forEach((tab, i) => {
    tab.classList.toggle("active", i === index);
    contents[i].classList.toggle("active", i === index);
  });
  document.querySelector(".sale-popup .tabs").scrollTo({
    left:
      tabs[index].offsetLeft -
      document.querySelector(".sale-popup .tabs").clientWidth / 2 +
      tabs[index].clientWidth / 2,
  });
}
document.querySelectorAll("#MainContent announcement-bar").forEach((item) =>
  item.addEventListener("click", function () {
    showAnnounceSale();
  })
);
document.querySelectorAll(".shopify-section-group-footer-group announcement-bar").forEach((item) =>
  item.addEventListener("click", function () {
    showAnnounceSale();
  })
);